<template>
  <div class="site-view">
    <Header />

    <!--Main Image section-->
    <section class="home-banner">
      <video class="hero-animation responsive-img hide-on-med-and-down" playsinline autoplay muted loop poster="assets/images/StIves/mayor/Mayor_poster.png">
        <source
          type="video/webm"
          src="@/assets/images/StIves/videos/Hero_banner_v2.webm"
        />
      </video>
      <div class="container">
        <div class="banner-box">
          <h1>Your St Ives, <br> <span class="extended-title">Your Say</span> </h1>
          <hr>
          <h4>
           <span><strong>The Future in Your Hands. </strong> </span><br><br>We are making plans to improve the road network around St Ives – but we want those plans to be guided by you.
          </h4>
          <div class="banner-links">
            <div class="row">
              <div class="col s0 m6">
                <a href="#quotes-section"
                  ><button class="link2">Learn More</button></a
                >
              </div>
              <div class="col s0 m6">
                <a href="/map/entity/gnzMtAZnfEwWjsUW3IHX/addentity/feedback"
                  ><button class="link1">Have Your Say!</button></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="page-section highlight">
      <div class="container">
        <div class="row">
          <div class="col s12 m6">This  an early chance to influence and shape the plans before any decision on the final scheme is made. So please browse through the options and let us know which you prefer. </div>
          <div class="col s12 m6">The public engagement closes on 5th July at 5pm. If you would like a brochure, please call  0800 054 1163.</div>
        </div>
      </div>
      
    </section>

    <!--Mayor Welcome section-->
    <section class="page-section quotes" id="quotes-section">
      <div class="container">
        <div class="row">
          <div class="col m12 l6">
            <div class="video-box">
              <video
                width="100%"
                height="auto"
                controls
                poster=""
              >
                <source
                  type="video/mp4"
                  src="@/assets/images/StIves/videos/mayor_vid.mp4"
                />
              </video>
            </div>
          </div>
          <div class="col m12 l6">
            <div class="article article-text">
              <div class="article-card">
                <h3>Introduction from the Mayor</h3>
                <p>
                  “At the Combined Authority we want to upgrade St Ives road
                  network but we don't want to do it without hearing your views
                  first...”
                </p>
                <div class="portrait-name">
                  <div class="row">
                    <div class="col s2">
                      <div class="portrait">

                      </div>
                    </div>
                    <div class="col s10">
                      <div class="nameTitle">
                        <p>Dr Nik Johnson</p>
                        <p class="largeTitle">
                          Mayor of Cambridgeshire &amp; Peterborough
                        </p>
                        <p class="shortTitle">Mayor</p>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--Introduction section-->
    <section class="page-section challenge moped">
      <!-- <video class="right-side-image webm-video" playsinline autoplay muted loop>
        <source
          type="video/webm"
          src="@/assets/images/StIves/videos/Girl_mooped.webm"
        />
      </video> -->
      <img
        src="@/assets/images/StIves/gifs/Mooped_Right.gif"
        class="right-side-image"
      />
      <div class="container">
        <h1>Introduction</h1>
        <hr class="header-underline" />
        <div class="page-accordions">
          <div
            :id="`accordion_${index}`"
            class="accordion"
            v-for="(accordion, index) in accordions"
            :key="`home_accordion_${index}`"
            @click="() => accordionToggle(index)"
          >
            <div class="row">
              <div class="col s10">
                <h3>{{ accordion.question }}</h3>
              </div>
              <div class="col s2">
                <div class="accordion-icon">
                  <i class="fas fa-chevron-down"></i>
                </div>
              </div>
            </div>

            <div>
              <p
                class="accordion-text"
                v-for="(answer, j) in accordion.answer"
                :key="`accordion_${index}_answer_${j}`"
              >
                {{ answer }}
                <ul class="accord_list" v-if="index === 1 && j === 1">
                <li v-for="(point, a) in accordion.list" :key="`point_${a}`">
                  {{ point }}
                </li>
              </ul>
              </p>
              <p v-if="accordion.link"><a :href="accordion.link">{{accordion.link}}</a></p>
              
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--Current challenges section-->
    <section class="page-section lake-house">
      <!-- <img
        src="@/assets/images/StIves/placeholder/St-Ives_Left-Plant_150ppi.png"
        class="left-side-image"
      /> -->
       <video class="left-side-image webm-video" playsinline autoplay muted loop>
        <source
          type="video/webm"
          src="@/assets/images/StIves/videos/plant.webm"
        />
      </video>
      <div class="container">
        <h1>Current Challenges</h1>
        <hr class="header-underline" />
        <div class="card-space discs">
          <div
            class="card"
            v-for="(challenge, index) in challenges"
            :key="`home_challenges_${index}`"
          >
            <div v-if="index < 4"
              :style="{
                backgroundImage:
                  'url(' +
                  require('@/assets/images/StIves/challenges/icon' +
                    (index + 1) +
                    '.png') +
                  ')',
              }"
            ></div>
            <div v-if="index > 4"
              :style="{
                backgroundImage:
                  'url(' +
                  require('@/assets/images/StIves/challenges/icon' +
                    (index) +
                    '.png') +
                  ')',
              }"
            ></div>
            <h3>{{ challenge.header }}</h3>
          </div>
        </div>
      </div>
    </section>

    <!--Earlier challenges section-->
    <section class="page-section pinkbg pond">
      <!-- <img
        src="@/assets/images/StIves/placeholder/St-Ives_Left-Plant_150ppi.png"
        class="left-side-image"
      /> -->
      <img
        src="@/assets/images/StIves/gifs/boy-and-dog_gif_gray.gif"
        class="full-image"
      />
      <!-- <video class="full-image webm-video" playsinline autoplay muted loop>
        <source
          type="video/webm"
          src="@/assets/images/StIves/videos/boy_and_dog_gif_gray.webm"
        />
      </video> -->
      <div class="container">
        <div class="row">
          <div class="col m12 l12">
            <div class="article dark" style="width: 100%">
              <h1 class="title-compact">
                Environmental considerations
              </h1>
              <hr class="header-underline" style="width: 40%" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col m12 l6">
            <div class="article dark" style="width: 100%">
              <p>
               The River Great Ouse is a dominant feature in St Ives, with floodplain grassland, woodland and hedges scattered through the area. Many of the main roads such as the A1096 and A1123 are lined by trees. 
              </p>
              <!-- <ul>
                <li
                  v-for="(concern, index) in concerns"
                  :key="`concern_${index}`"
                >
                  {{ concern }}
                </li>
              </ul> -->
              <p>
                There is one international designated
site of Conservation Importance
and four designated sites of nature
conservation importance (SSSIs). 
              </p>
              <p>
                The A1123 corridor (Houghton Hill
Road, Houghton Road and St Audrey
Lane) and the A1096 corridor (Harrison
Way and London Road) are major traffic
noise corridors identified as priority
areas for reducing traffic noise levels.
              </p>
            </div>
          </div>
          <div class="col s5"></div>
        </div>
      </div>
    </section>

    <!--have your say section-->
    <section class="page-section survey">
      <video class="full-image webm-video" playsinline autoplay muted loop>
        <source
          type="video/webm"
          src="@/assets/images/StIves/videos/cyclist.webm"
        />
      </video>
      <img src="@/assets/images/StIves/placeholder/St-Ives_Cyclist_150ppi.png" class="response-img">
      <div class="container">
        <div class="row">
          <div class="col m12 l7">
            <div class="summary-card">
              <h1>Have Your Say!</h1>
              <hr class="header-underline" />
              <p>
                This is your St Ives, your future. Your opinion will shape the all-important decision on how and where we should improve the St Ives road network.  Please now consider the options and tell us which you prefer.
              </p>
              <a href="/map/entity/gnzMtAZnfEwWjsUW3IHX/addentity/feedback"
                ><button class="link1">Have Your Say!</button></a
              >
            </div>
          </div>
          <div class="com m0 l5"></div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Header from "@/components/a141/Header";
import Footer from "@/components/customPages/components/footer";
export default {
  name: "homePage",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      accordions: [
        {
          active: false,
          question: "Why does the St Ives road network matter?",
          answer: [
            "The St Ives transport network is not just vital for the market town of St Ives and its surrounding villages, but it also has strategic importance to the region and its future growth. Through St Ives the A1123 is a key east-west link, especially during peak times. To the west, it connects St Ives with Huntingdon and RAF Wyton via the B1090 and the A141 corridor which joins the A14 and A1 strategic road networks. ",
            "To the east, the A1123 links to Earith and local quarries. To the south of St Ives, the A1096 (Harrison Way/London Road) also connects to the A14 via the A1307. ",
            "The St Ives network and the A141 corridor are interlinked therefore any improvements must be ‘joined up’ to achieve the best results. Traffic conditions on either network can directly influence the volume and flow of traffic travelling through the neighbouring network.",
            "To view the current ongoing work with the A141, please visit:",
          ],
          link: "www.youra141.co.uk",
        },
        {
          active: false,
          question: "What is the problem?",
          answer: [
            "The St Ives road network plays a key role but can get severely congested, particularly during peak times. The A1123 and A1096 are congestion hotspots, especially in the morning and evening rush hour. Morning rush hour congestion along North Road, East Street and The Quadrant towards Harrison Way can delay buses by over 20 minutes. There are pinch points in North Road, East Street and Station Road because narrow carriageways and street parking prevent buses passing other vehicles. ",
            "Thousands use the St Ives road network to commute to school and work etc. The rise in heavy good vehicles, vans, and agricultural vehicles using the roads also adds to the increasing congestion around St Ives. Car ownership is high in St Ives with over two-thirds of residents getting to work by a vehicle.",
            "The Cambridgeshire Guided Busway runs between St Ives Park and Ride and Cambridge with services continuing throughout Huntingdonshire. Two National Cycle Routes, which are mostly traffic-free, run through St Ives and converge near Huntingdon Train Station. However, the cycling infrastructure and footpaths within St Ives are patchy, badly signed, and poorly maintained. They do not connect up as well as they could to encourage active travel, benefit health and provide environment benefits.",
          ],
          link: "",
        },
      ],
      challenges: [
        {
          header: "Peak time congestion",
        },
        {
          header:
            "Unreliable journey times for local public transport, cars, and freight vehicles",
        },
        {
          header: "Lack of safe, joined-up cycle or walking routes",
        },
        {
          header: "Rat-running through St Ives",
        },
        {
          header: "",
        },
        {
          header: "Lack of active travel options",
        },
        {
          header: "Air and noise quality issues due to congestion",
        },
        {
          header: "Limited provision for public transport",
        },
      ],
      concerns: [
        "There is one international designated site of Conservation Importance and four 	designated sites of nature conservation importance (SSSIs).   ",
        "The A1123 corridor (Houghton Hill Road, Houghton Road and St. Audrey Lane) is a 	major traffic noise corridor. There are pinch points in North Road, East Street and Station 	Road because narrow carriageways and street parking prevent buses passing other 	vehicles.  ",
      ],
    };
  },

  methods: {
    accordionToggle(index) {
      let accordionElement = document.getElementById(`accordion_${index}`);

      if (!this.accordions[index].active) {
        accordionElement.classList.add("open");
        this.accordions[index].active = true;
      } else {
        accordionElement.classList.remove("open");
        this.accordions[index].active = false;
      }
    },
  },

  computed: {
    ...mapState(["entities", "entityTypes"]),
    ...mapGetters(["user", "allEntityTypes", "allEntities"]),
  },

  async mounted() {
    // this.populateTimeline();
    if (this.entities.length == 0) {
      await this.$store.dispatch("populateEntities");
    }
  },
};
</script>

